/*
 * @Description: 本地存储，可设置过期时间 用于保存 token 等有时效的数据
 * @Author: luozhao
 * @Date: 2021-04-01 15:59:45
 */

class BetterStroage {
  constructor(stroage) {
    const allowedParams = ['sessionStorage', 'localStorage'];
    if (allowedParams.indexOf(stroage) < 0) {
      stroage = 'sessionStorage';
    }
    this.storage = window[stroage];
  }
  get (key) {
    let value = this.storage.getItem(key);
    if (!value) {
      return false;
    }
    let formatValue = JSON.parse(value);
    const now = +new Date();
    if (formatValue.expire && now > formatValue.expire) {
      return false;
    }
    return formatValue.value;
  }
  set (key, value, expire) {
    const now = +new Date();
    expire = now + expire;
    let formatValue = {
      value,
      expire
    };
    this.storage.setItem(key, JSON.stringify(formatValue));
  }
  remove (key) {
    this.storage.removeItem(key);
  }
  clear () {
    this.storage.clear();
  }
}

export default BetterStroage;
